import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import CMPBanner from './CMPBanner';

class CMPBannerPortal extends Component {

    constructor(props) {
        super(props);
        this.element = document.createElement('div');
    }

    componentDidMount() {
        if (document.querySelector('#js-app-cmp-banner')) {
            document.querySelector('#js-app-cmp-banner').appendChild(this.element);
        }
    }

    componentWillUnmount() {
        if (document.querySelector('#js-app-cmp-banner')) {
            document.querySelector('#js-app-cmp-banner').removeChild(this.element);
        }
    }

    renderPortalContent() {
        return (
            <CMPBanner />
        );
    }

    render() {
        return ReactDOM.createPortal(
            this.renderPortalContent(),
            this.element,
        );
    }

}


export default CMPBannerPortal;
